export default function AppNavIcon() {
    return (
        <svg aria-label="App Icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 7C10 9.76142 7.76142 12 5 12C2.23858 12 0 9.76142 0 7C0 4.23858 2.23858 2 5 2C7.76142 2 10 4.23858 10 7Z"
                fill="var(--primary)"/>
            <path
                d="M20 11.5C20 15.6421 16.6421 19 12.5 19C8.35786 19 5 15.6421 5 11.5C5 7.35786 8.35786 4 12.5 4C16.6421 4 20 7.35786 20 11.5Z"
                fill="var(--secondary)"/>
            <path
                d="M5.5 16C5.5 14.7455 5.83939 13.6818 6.51818 12.8091C7.19697 11.9364 8.02424 11.5 9 11.5C8.02424 11.5 7.19697 11.0636 6.51818 10.1909C5.83939 9.31818 5.5 8.25455 5.5 7C5.5 8.25455 5.16061 9.31818 4.48182 10.1909C3.80303 11.0636 2.97576 11.5 2 11.5C2.97576 11.5 3.80303 11.9364 4.48182 12.8091C5.16061 13.6818 5.5 14.7455 5.5 16Z"
                fill="var(--light)"/>
        </svg>

    )
}
